import React, { useState } from 'react'
import useModal from '../../../../../../Components/CustomModal/useModal';
import { useDispatch, useSelector } from 'react-redux';
import { Pencil, Trash2 } from 'lucide-react';
import axios from 'axios';
import { V_URL } from '../../../../../../BaseUrl';
import Swal from 'sweetalert2';
import ManualReturnModel from './ManualReturnModel';
import AutoReturnModel from './AutoReturnModel';
import { getViewReturnItems } from '../../../../../../Store/prosafe/proTransaction/PurReturn/getViewReturnItems';

const PurReturnItems = ({ itemsArr, setItemsArr, data, form, setForm }) => {

  const [activeModal, setActiveModal] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editItemId, setEditItemId] = useState(null);
  const modal = useModal();
  const dispatch = useDispatch();

  const itemData = useSelector((state) => state.getItem?.user?.data) || [];

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditItemId(itemsArr[index]._id);
    setActiveModal('manual');
    modal.show();
  };

  const handleSubmit = (itData) => {
    if (editingIndex !== null) {
      const updatedItems = [...itemsArr];
      updatedItems[editingIndex] = itData;
      setItemsArr(updatedItems);
      setEditingIndex(null);
    } else {
      setItemsArr([...itemsArr, itData]);
    }
  }

  const handleDelete = async (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const itemToDelete = itemsArr[index];
        if (data?._id && itemToDelete?._id) {
          try {
            const payload = {
              id: data._id,
              itemId: itemToDelete._id,
            };
            await axios({
              method: "put",
              url: `${V_URL}/prosafe/pro-delete-pur-item`,
              data: payload,
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
              },
            });
            dispatch(getViewReturnItems({ formData: { id: data?._id } }));
            Swal.fire('Deleted!', 'The item has been deleted.', 'success');
          } catch (error) {
            Swal.fire('Error!', 'Failed to delete item.', 'error');
            console.error('Delete error:', error);
          }
        } else {
          const updatedItems = [...itemsArr];
          updatedItems.splice(index, 1);
          setItemsArr(updatedItems);
          Swal.fire('Deleted!', 'The item has been deleted.', 'success');
        }
      }
    });
  };

  const getItemName = (itemId) => {
    const item = itemData.find(item => item._id === itemId);
    return item ? item.name : 'N/A';
  };

  return (
    <div className='row'>
      <div className='col-md-12'>
        <div className="card">
          <div className="card-body">
            <div className="col-12 d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex gap-2 align-items-center">
                <h4>Items Details List</h4>
                {(!form?.party_id) && (
                  <span className="alert alert-warning p-2">Please select the party for adding the items.</span>
                )}
              </div>
              {form?.party_id && (
                <div className="add-group">
                  <button
                    type="button"
                    className="btn btn-primary add-pluss ms-2 w-100"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => {
                      setActiveModal('auto');
                      modal.show();
                    }}
                    title="Add Auto">
                    Auto
                    <img src="/assets/img/icons/plus.svg" alt="add-icon" className='mx-1' />
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary add-pluss ms-2 w-100"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => {
                      setActiveModal('manual');
                      modal.show();
                    }}
                    title="Add Manual">
                    Manual
                    <img src="/assets/img/icons/plus.svg" alt="add-icon" className='mx-1' />
                  </button>
                </div>
              )}
            </div>
            <div className="table-responsive">
              <table className="table border-0 mb-0 custom-table table-striped comman-table">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Item Name</th>
                    <th>Item No.</th>
                    <th>Length(mm)</th>
                    <th>Width(mm)</th>
                    <th>Weight(kg)</th>
                    <th>Assem. Weight(kg)</th>
                    <th>ASM(sqm)</th>
                    <th>Return Qty</th>
                    <th>Rate(₹)</th>
                    <th>Amount(₹)</th>
                    <th>Discount(%)</th>
                    <th>Discount Amount(₹)</th>
                    <th>Sp. Discount(%)</th>
                    <th>Sp. Discount Amount(₹)</th>
                    <th>Taxable Amount(₹)</th>
                    <th>GST(%)</th>
                    <th>GST Amount(₹)</th>
                    <th>Total Amount(₹)</th>
                    <th>Heat/Lot No.</th>
                    <th>Plat No.</th>
                    <th>TC No.</th>
                    <th>Type</th>
                    <th>Remarks</th>
                    <th className="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {itemsArr?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{getItemName(item.item_id)}</td>
                      <td>{item.item_no}</td>
                      <td>{item.item_length || '-'}</td>
                      <td>{item.item_width || '-'}</td>
                      <td>{item.item_weight || '-'}</td>
                      <td>{item.assembly_weight || '-'}</td>
                      <td>{item.assembly_surface_area || '-'}</td>
                      <td>{item.quantity ?? '-'}</td>
                      <td>{item.rate ? Number(item.rate).toFixed(2) : '-'}</td>
                      <td>{item.amount ? Number(item.amount).toFixed(2) : '-'}</td>
                      <td>{item.discount ? Number(item.discount).toFixed(2) : '-'}</td>
                      <td>{item.discount_amount ? Number(item.discount_amount).toFixed(2) : '-'}</td>
                      <td>{item.sp_discount ? Number(item.sp_discount).toFixed(2) : '-'}</td>
                      <td>{item.sp_discount_amount ? Number(item.sp_discount_amount).toFixed(2) : '-'}</td>
                      <td>{item.taxable_amount ? Number(item.taxable_amount).toFixed(2) : '-'}</td>
                      <td>{item.gst ? Number(item.gst).toFixed(2) : '-'}</td>
                      <td>{item.gst_amount ? Number(item.gst_amount).toFixed(2) : '-'}</td>
                      <td>{item.total_amount ? Number(item.total_amount).toFixed(2) : '-'}</td>
                      <td>{item.heat_no || "-"}</td>
                      <td>{item.plat_no || "-"}</td>
                      <td>{item.tc_no || "-"}</td>
                      <td>{item.isAuto ? "Auto" : "Manual"}</td>
                      <td>{item.remarks || '-'}</td>
                      <td className="d-flex justify-content-end">
                        <a className='action-icon mx-1' style={{ cursor: "pointer" }}
                          data-toggle="tooltip" data-placement="top" title="Edit"
                          onClick={() => handleEdit(index)}
                        >
                          <Pencil />
                        </a>
                        <a className='action-icon mx-1' style={{ cursor: "pointer" }}
                          data-toggle="tooltip" data-placement="top" title="Delete"
                          onClick={() => handleDelete(index)}
                        >
                          <Trash2 />
                        </a>
                      </td>
                    </tr>
                  ))}
                  {itemsArr?.length === 0 ? (
                    <tr>
                      <td colSpan="999">
                        <div className="no-table-data">
                          No Data Found!
                        </div>
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {activeModal === 'manual' && (
        <ManualReturnModel
          itemsArr={itemsArr}
          editingIndex={editingIndex}
          setEditingIndex={setEditingIndex}
          data={data}
          onSubmit={handleSubmit}
          modal={{
            ...modal,
            onClose: () => {
              modal.hide();
              setActiveModal(null);
              setEditingIndex(null);
              setEditItemId(null);
            }
          }}
          editItemId={editItemId}
          setEditItemId={setEditItemId}
        />
      )}

      {activeModal === 'auto' && (
        <AutoReturnModel
          modal={{
            ...modal,
            onClose: () => {
              modal.hide();
              setActiveModal(null);
            }
          }}
          itemsArr={itemsArr}
          setItemsArr={setItemsArr}
          form={form}
          data={data}
          setForm={setForm}
        />
      )}
    </div>
  )
}

export default PurReturnItems